import { useParams, Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { Card, Btn } from "@/components/kit";

const LABELS = {
  financeiro: "Financeiro", rh: "RH", juridico: "Jurídico", operacoes: "Operações",
  marketing: "Marketing", administrativo: "Administrativo", suporte: "Suporte", desenvolvimento: "Desenvolvimento",
};
const DESC = {
  financeiro: "Contas a pagar/receber, faturas, fluxo de caixa e resumos financeiros.",
  rh: "Colaboradores, admissões, férias, avisos e documentos de RH.",
  juridico: "Contratos, prazos, pareceres e alertas jurídicos.",
  operacoes: "Processos, ordens de serviço e acompanhamento operacional.",
  marketing: "Campanhas, materiais e calendário de marketing.",
  administrativo: "Rotinas administrativas, compras e contratos internos.",
  suporte: "Chamados e atendimento ao cliente.",
  desenvolvimento: "Projetos e entregas de desenvolvimento.",
};

export default function Setor() {
  const { key } = useParams();
  const label = LABELS[key] || (key ? key.charAt(0).toUpperCase() + key.slice(1) : "Setor");
  return (
    <div className="space-y-6" data-testid={`setor-${key}`}>
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-zinc-900">{label}</h1>
        <p className="mt-1 text-sm text-zinc-500">Área do setor {label}.</p>
      </div>
      <Card className="flex flex-col items-center justify-center gap-4 p-12 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600"><Building2 size={26} /></span>
        <div>
          <h2 className="font-display text-lg font-semibold text-zinc-900">Em breve</h2>
          <p className="mx-auto mt-1 max-w-md text-sm text-zinc-500">
            {DESC[key] || "Este setor será habilitado em breve com o que é pertinente à área."} A ISA já está pronta
            para crescer para todos os setores da empresa — o Comercial é o primeiro, já 100% funcional.
          </p>
        </div>
        <Link to="/app/comercial"><Btn variant="ghost" data-testid="setor-go-comercial">Ir para o Comercial (pronto)</Btn></Link>
      </Card>
    </div>
  );
}
